import { render, staticRenderFns } from "./Xomes.vue?vue&type=template&id=6631f457&scoped=true&"
import script from "./Xomes.vue?vue&type=script&lang=js&"
export * from "./Xomes.vue?vue&type=script&lang=js&"
import style0 from "./Xomes.vue?vue&type=style&index=0&id=6631f457&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6631f457",
  null
  
)

export default component.exports